/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserActivateDto
 */
export interface UserActivateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserActivateDto
     */
    userIds: Array<string>;
}

export function UserActivateDtoFromJSON(json: any): UserActivateDto {
    return UserActivateDtoFromJSONTyped(json, false);
}

export function UserActivateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserActivateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIds': json['userIds'],
    };
}

export function UserActivateDtoToJSON(value?: UserActivateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userIds': value.userIds,
    };
}

